// actionTypes.ts
const FUEL_SUPPLIER_ACTIONS = {
  SHOW_ADD: "FUEL_SUPPLIER_ACTION_SHOW_ADD",
  SHOW_EDIT: "FUEL_SUPPLIER_ACTION_SHOW_EDIT",
  CONFIRM_EDIT: "FUEL_SUPPLIER_ACTION_CONFIRM_EDIT",
  SHOW_DEACTIVATE: "FUEL_SUPPLIER_ACTION_SHOW_DEACTIVATE",
  CONFIRM_DEACTIVATE: "FUEL_SUPPLIER_ACTION_CONFIRM_DEACTIVATE",
  SHOW_ACTIVATE: "FUEL_SUPPLIER_ACTION_SHOW_ACTIVATE",
  CONFIRM_ACTIVATE: "FUEL_SUPPLIER_ACTION_CONFIRM_ACTIVATE",
  SORT: "FUEL_SUPPLIER_ACTION_SORT",
  ADD_NEW: "FUEL_SUPPLIER_ACTION_ADD_NEW",
  EDIT: "FUEL_SUPPLIER_ACTION_EDIT",
  DROP: "FUEL_SUPPLIER_ACTION_DROP",
  CLOSE: "FUEL_SUPPLIER_ACTION_CLOSE",
};

const CXAirLineTypeOptions = [
  {
    text: "CPA",
    value: "CPA",
  },
  {
    text: "AHK",
    value: "AHK",
  },
];

const UOAirLineTypeOptions = [
  {
    text: "HKE",
    value: "HKE",
  }
];

export {
  FUEL_SUPPLIER_ACTIONS,
  CXAirLineTypeOptions,
  UOAirLineTypeOptions,
};
